export default {
  "Sound Options": {
    "Music Volume": "85",
    "Voiceover Volume": "85",
    "Sound Effects Volume": "85",
    "Movie Volume": "100",
    "Number 3D Voices": "16",
    "Number 2D Voices": "24",
    "2D3D Bias": "1.00",
    "Force Software": "0",
    "EAX": "0",
    "Sound Init": "0",
    "Disable Sound": "0"
  },
  "Graphics Options": {
    "V-Sync": "0",
    "Anisotropy": "1",
    "Frame Buffer": "1",
    "Anti Aliasing": "0",
    "Texture Quality": "0",
    "Grass": "1",
    "Soft Shadows": "1",
    "Shadows": "1",
    "Brightness": "57",
    "EnableHardwareMouse": "1",
    "FullScreen": "0"
  },
  "Game Options": {
    "Enable Tooltips": "1",
    "Keyboard Camera Deceleration": "2000.000000",
    "Keyboard Camera Acceleration": "500.000000",
    "Keyboard Camera DPS": "200.000000",
    "Hide InGame GUI": "0",
    "Use Small Fonts": "0",
    "Hide Unequippable": "0",
    "Tutorial Popups": "1",
    "Subtitles": "1",
    "Mini Map": "1",
    "Floating Numbers": "1",
    "Status Summary": "1",
    "Enable Mouse Teleporting To Buttons": "1",
    "Mouse Sensitivity": "44",
    "Difficulty Level": "1",
    "Auto Level Up NPCs": "0",
    "Mouse Look": "0",
    "AutoSave": "1",
    "GUIsInScreenShot": "1",
    "EnableScreenShot": "0",
    "Reverse Mouse Buttons": "0",
    "Reverse Minigame YAxis": "0",
    "Combat Movement": "1",
    "TooltipDelay Sec": "1"
  },
  "Keymapping": {
    "Action286B": "8",
    "Action286A": "7",
    "Action285B": "10",
    "Action285A": "9",
    "Action284B": "54",
    "Action284A": "51",
    "Action283B": "54",
    "Action283A": "51",
    "Action282B": "69",
    "Action282A": "73",
    "Action281B": "53",
    "Action281A": "76",
    "Action280B": "69",
    "Action280A": "73",
    "Action264": "57",
    "Action263": "43",
    "Action262": "85",
    "Action261": "84",
    "Action260": "83",
    "Action259": "82",
    "Action258": "81",
    "Action257": "80",
    "Action256": "79",
    "Action255": "78",
    "Action254": "77",
    "Action253": "31",
    "Action245": "75",
    "Action244": "55",
    "Action243": "67",
    "Action242": "74",
    "Action241": "87",
    "Action240": "56",
    "Action239": "68",
    "Action238": "82",
    "Action236": "83",
    "Action234": "81",
    "Action232": "80",
    "Action230": "79",
    "Action228": "78",
    "Action226": "77",
    "Action225": "70",
    "Action224": "90",
    "Action223": "31",
    "Action222": "25",
    "Action221": "24",
    "Action220": "29",
    "Action219": "28",
    "Action218": "42",
    "Action217": "87",
    "Action216": "65",
    "Action215": "63",
    "Action214": "62",
    "Action213": "60",
    "Action212": "61",
    "Action211": "66",
    "Action210": "59",
    "Action209": "71",
    "Action208": "89",
    "Action207": "72",
    "Action206": "30",
    "Action205": "55",
    "Action204": "67"
  },
  "Autopause Options": {
    "End Of Combat Round": "0",
    "Mine Sighted": "1",
    "Enemy Sighted": "1",
    "Party Killed": "1",
    "Action Menu": "0",
    "New Target Selected": "1"
  },
  "Movies Shown": {
    "Movie10": "0",
    "Movie 9": "0",
    "Movie 8": "0",
    "Movie 7": "0",
    "Movie 6": "0",
    "Movie 5": "0",
    "Movie 4": "0",
    "Movie 3": "0",
    "Movie 2": "0",
    "Movie 1": "0",
    "Movie 0": "0"
  }
};
